import React from 'react';
import { createPortal } from 'react-dom';
import SweetAlert from 'react-bootstrap-sweetalert';

/**
 * PortalSweetAlert - A wrapper component that renders SweetAlert in a portal
 * This ensures the modal appears on top of all other elements regardless of z-index stacking contexts
 */
function PortalSweetAlert({ children, ...props }) {
  // Create a portal that renders directly to document.body
  return createPortal(<SweetAlert {...props}>{children}</SweetAlert>, document.body);
}

export default PortalSweetAlert;
